import { observer } from 'mobx-react';
import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import ImageIcon from '@mui/icons-material/Image';
import { Avatar, Button, CircularProgress } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import HomePageStore from './store/HomePageStore';
import HomePageListModal from './component/HomePageListModal';
import { EmployeeModel } from 'domains/models/EmployeeModel';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import BasicImage from 'pages/MyPage/component/BasicImage';
import { Typography } from 'antd';
import { AggregationDone, AggregationTodo } from 'domains/models/AggregationModel';
import { useRootStore } from 'store/StoreContextProvider';

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  // "@keyframes ripple": {
  //   "0%": {
  //     transform: "scale(.8)",
  //     opacity: 1,
  //   },
  //   "100%": {
  //     transform: "scale(2.4)",
  //     opacity: 0,
  //   },
  // },
}));

const UnStyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#b7b7b7',
    color: '#b7b7b7',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  // "@keyframes ripple": {
  //   "0%": {
  //     transform: "scale(.8)",
  //     opacity: 1,
  //   },
  //   "100%": {
  //     transform: "scale(2.4)",
  //     opacity: 0,
  //   },
  // },
}));

interface Props {
  pageStore: HomePageStore;
}
function HomePageListView(props: Props) {
  const { pageStore } = props;
  const { loginStore } = useRootStore();

  const navigate = useNavigate();

  const handleClickTarget = (target: EmployeeModel) => {
    pageStore.setCurrentUser(target);
    pageStore.setIsOpenModal(true);
  };

  const handleClickEmployee = (employee: EmployeeModel) => {
    navigate('employee-detail', { state: { employee: toJS(employee) } });
  };

  return pageStore.isLoading ? (
    <Grid2 container justifyContent={'center'} style={{ marginTop: '200px' }}>
      <CircularProgress />
    </Grid2>
  ) : (
    <Grid2 container spacing={2} style={{ paddingBottom: '100px' }}>
      {pageStore.employeeList?.map((employee) => {
        return (
          <Grid2 xs={12} sm={12} md={4} key={employee.id}>
            <ListItem
              key={employee?.names?.fullname}
              style={{
                border: '1px solid #dddddd',
                borderRadius: '15px',
                marginBottom: '14px',
                padding: '18px',
                position: 'relative',
              }}
              sx={{
                '&:hover': {
                  cursor: employee?.displayCount === 0 ? '' : 'pointer',
                },
              }}
              secondaryAction={
                <Button
                  style={{
                    margin: '0 5 0 5',
                    background: '#249EE7',
                    opacity: '1',
                    color: '#ffffff',
                    borderRadius: '10px',
                    height: '35px',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleClickTarget(employee)}
                >
                  <span
                    style={{
                      fontStyle: 'normal',
                      fontWeight: 500,
                      fontSize: '12px',
                      lineHeight: '12px',
                    }}
                  >
                    Goals
                  </span>
                </Button>
              }
            >
              {employee?.displayCount === 0 ? (
                <UnStyledBadge overlap='circular' anchorOrigin={{ vertical: 'top', horizontal: 'right' }} variant='dot'>
                  {employee.userData?.profile ? (
                    <BasicImage
                      src={employee.userData?.profile}
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        overflow: 'hidden',
                      }}
                    />
                  ) : (
                    <Avatar>
                      <ImageIcon
                        sx={{
                          borderRadius: '50%',
                          objectFit: 'cover',
                          overflow: 'hidden',
                        }}
                      />
                    </Avatar>
                  )}
                </UnStyledBadge>
              ) : (
                <StyledBadge overlap='circular' anchorOrigin={{ vertical: 'top', horizontal: 'right' }} variant='dot'>
                  {employee.userData?.profile ? (
                    <BasicImage
                      src={employee.userData?.profile}
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        overflow: 'hidden',
                      }}
                    />
                  ) : (
                    <Avatar>
                      <ImageIcon
                        sx={{
                          borderRadius: '50%',
                          objectFit: 'cover',
                          overflow: 'hidden',
                        }}
                      />
                    </Avatar>
                  )}
                </StyledBadge>
              )}

              <ListItemText
                primary={
                  <span
                    style={{
                      fontFamily: 'Pretendard',
                      fontStyle: 'normal',
                      fontWeight: 600,
                      fontSize: '16px',
                      lineHeight: '16px',
                      color: '#000000',
                      cursor: 'pointer',
                      opacity: employee?.displayCount === 0 ? '0.3' : '1',
                    }}
                  >
                    {employee?.names?.fullname}
                  </span>
                }
                secondary={
                  <span
                    style={{
                      fontFamily: 'Pretendard',
                      fontStyle: 'normal',
                      cursor: 'pointer',
                      fontWeight: 500,
                      fontSize: '14px',
                      lineHeight: '14px',
                      color: '#212121',
                      opacity: employee?.displayCount === 0 ? '0.3' : '1',
                    }}
                  >
                    {employee.userData.jobTitle}
                    {'  '}
                    <span
                      style={{
                        fontWeight: 400,
                        fontSize: '12px',
                        lineHeight: '12px',
                        color: '#6C6B6F',
                        opacity: employee?.displayCount === 0 ? '0.3' : '1',
                      }}
                    >
                      {employee.userData.deptName}
                    </span>
                  </span>
                }
                onClick={(e) => handleClickEmployee(employee)}
                style={{
                  margin: 0,
                  marginLeft: '16px',
                }}
              />
              <Typography
                style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-10px',
                  color: 'white',
                  fontSize: 13,
                  fontWeight: 700,
                  fontFamily: 'Pretendard',
                  background: 'red',
                  borderRadius: '10px',
                  width: '40px',
                  height: '20px',
                  textAlign: 'center',
                }}
              >
                {employee?.displayCount && employee?.displayCount > 99 ? '99+' : employee?.displayCount}
              </Typography>
              {/* <Button variant='contained' onClick={() => handleClickTarget(employee)}></Button> */}
            </ListItem>
          </Grid2>
        );
      })}
      <HomePageListModal pageStore={pageStore} />
    </Grid2>
  );
}

export default observer(HomePageListView);
